// extracted by mini-css-extract-plugin
module.exports = {"image-slider":"ImageSlider_image-slider__1MQ56","hidden-image-slider":"ImageSlider_hidden-image-slider__2dOeL","prev":"ImageSlider_prev__1kU77","next":"ImageSlider_next__1rmtH"};